import {
    type DeleteContactFormResponseType,
    type DeleteContactFormRequestType
} from "./type";
import {
    request
} from "../request";

const deleteContactForm = async (
    params: DeleteContactFormRequestType
): Promise<DeleteContactFormResponseType> => {
    return await request<DeleteContactFormResponseType>(`/request/deleteContactForm/${params.id}`, {
        method: "DELETE"
    });
};
export default deleteContactForm;
